import React, { useCallback, SyntheticEvent } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { Box, Tabs, Tab, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

export enum JobTabType {
  CAMPAIGN_DETAILS = 'campaign_details',
  ATS = 'ats',
  COMMENTS_TIMELINE = 'comments_timeline',
}

const useStyles = makeStyles((theme: any) => ({
  root: {
    marginBottom: theme.spacing(6),
  },
  tabs: {
    // minHeight: 48,
  },
  tab: {
    minWidth: 100,
    textTransform: 'none',
    fontWeight: 500,
  },
  selectedTab: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
}));

interface JobTabsProps {
  jobId: string;
}

export const JobTabs: React.FC<JobTabsProps> = ({ jobId }) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  // Get the tab from the URL or default to CAMPAIGN_DETAILS
  const searchParams = new URLSearchParams(location.search);
  const currentTab =
    (searchParams.get('tab') as JobTabType) || JobTabType.CAMPAIGN_DETAILS;

  const handleTabChange = useCallback(
    (_event: SyntheticEvent, newValue: JobTabType) => {
      const params = new URLSearchParams(location.search);
      params.set('tab', newValue);
      history.push({
        pathname: location.pathname,
        search: params.toString(),
      });
    },
    [history, location],
  );

  return (
    <Box className={classes.root}>
      <Tabs
        value={currentTab}
        onChange={handleTabChange}
        aria-label="job details tabs"
        textColor="primary"
        indicatorColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        className={classes.tabs}
      >
        <Tab
          label={<Typography>CAMPAIGN DETAILS</Typography>}
          value={JobTabType.CAMPAIGN_DETAILS}
          className={classes.tab}
          classes={{ selected: classes.selectedTab }}
        />
        <Tab
          label={<Typography>ATS</Typography>}
          value={JobTabType.ATS}
          className={classes.tab}
          classes={{ selected: classes.selectedTab }}
        />
        <Tab
          label={<Typography>COMMENTS/TIMELINE</Typography>}
          value={JobTabType.COMMENTS_TIMELINE}
          className={classes.tab}
          classes={{ selected: classes.selectedTab }}
        />
      </Tabs>
    </Box>
  );
};
